<template>
  <Card dis-hover>
    <div slot="title">
      <slot name="title"></slot>
      <p class="title-item">{{ this.$t('common.this_month') }}</p>
    </div>
    <div id="task-overview"></div>
  </Card>
</template>
<script>
import * as echarts from 'echarts';
import api from '../../../api/home/index';
export default {
  data() {
    return {
      myChart: null,
    };
  },

  mounted() {
    this.initInfo();
  },
  methods: {
    myEchartsResize() {
      this.myChart && this.myChart.resize();
    },
    // 获取巡店基本情况数据
    initInfo() {
      api
        .taskModuleCount()
        .then(res => {
          // 初始化echarts
          //console.log(res,'taskModuleCount')
          this.initEcharts(res.data);
        })
        .catch(error => {
          console.log('err:', error);
          //this.$Message.error(`error`);
        });
    },
    initEcharts(resInfo) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('task-overview'), null, { renderer: 'svg' });
      let total = resInfo.total;
      resInfo.finshedPercent = Math.round((resInfo.finshed / total) * 100) || 0;
      resInfo.executingPercent = Math.round((resInfo.executing / total) * 100) || 0;
      if (resInfo.waiting != 0) {
        resInfo.waitingPercent = 100 - resInfo.finshedPercent - resInfo.executingPercent;
      } else {
        resInfo.waitingPercent = 0;
      }

      let option = {
        grid: {
          containLabel: true,
        },
        tooltip: {
          show: true,
          trigger: 'item',
          position: 'right',
          // formatter: "{a} : {c} ({d}%)",
          formatter: function (a) {
            if (a.name) {
              // return a.name+" "+a.value +" "+Math.round((a.value/total)*100)+"%";
              return `
                    <div><span style="display:inline-block;width:12px;height:12px;margin-right:10px;border-radius:2px;background-color:${a.color}"></span>${a.name}</div>
                    <span>${a.value} ，</span><span>  ${a.data.percentself}% </span>
                      `;
            }
          },
        },
        color: ['#FF9900', '#7ED321', '#CCCCCC'],
        legend: {
          orient: 'vertical',
          top: '40%',
          right: 0,
          itemHeight: 12, //图例的高度
          itemWidth: 12,
          itemGap: 12, //图例之间的间距
          textStyle: {
            rich: {
              n: {
                display: 'inline-block',
                width: 60,
              },
              v: {
                display: 'inline-block',
                width: 35,
              },
              s: {
                color: '#B2B2B2',
              },
            },
          },
          data: [
            this.$t('home.processing'), // '进行中',
            this.$t('home.solveProblemNum'), // '已完成',
            this.$t('home.unstart'), // '未开始'
          ],
          formatter: function (name) {
            let data1 = option.series[0].data;
            let data2 = option.series[1].data;
            let data3 = option.series[2].data;
            let data = data1.concat(data2, data3);
            let tarValue, percent;
            for (let i = 0; i < data.length; i++) {
              if (data[i].name === name) {
                tarValue = data[i].value;
                percent = data[i].percentself;
              }
            }
            return `{n|${name}}{v|${tarValue}}{s|${percent}%}`;
            // return name +`{a| }`+tarValue;
          },
          //图例的名字需要和饼图的name一致，才会显示图例
        },
        series: [
          {
            name: this.$t('home.processing'), //'进行中',
            type: 'pie',
            radius: ['70%', '80%'],
            center: ['30%', '53%'],
            emphasis: {
              scale: false,
            },
            //环的位置
            label: {
              show: true,
              position: 'center',
              rich: {
                b: {
                  fontSize: 20,
                  fontWeight: 'bold',
                  color: '#333333',
                  lineHeight: '26',
                },
              },
              formatter: `{b|${total}}\n${this.$t('home.total_tasks')}`,
            },
            labelLine: {
              show: false,
            },

            data: [
              {
                value: resInfo.executing, //需要显示的数据
                percentself: resInfo.executingPercent,
                name: this.$t('home.processing'), //'进行中',
                itemStyle: {
                  color: '#FF9900',
                },
              },
              {
                value: total - resInfo.executing,
                //不需要显示的数据，颜色设置成和背景一样
                itemStyle: {
                  color: 'transparent',
                },
              },
            ],
          },
          {
            name: this.$t('home.solveProblemNum'), //'已完成',
            type: 'pie',
            radius: ['59%', '69%'],
            center: ['30%', '53%'],
            emphasis: {
              scale: false,
            },
            label: {
              show: true,
              position: 'center',
              formatter: `{b|${total}}\n${this.$t('home.total_tasks')}`,
              rich: {
                b: {
                  fontSize: 20,
                  fontWeight: 'bold',
                  color: '#333333',
                  lineHeight: '26',
                },
              },
            },
            labelLine: {
              show: false,
            },

            data: [
              {
                name: this.$t('home.solveProblemNum'), //'已完成',
                percentself: resInfo.finshedPercent,
                value: resInfo.finshed,
                itemStyle: {
                  color: '#7ED321',
                },
              },
              {
                value: total - resInfo.finshed,
                itemStyle: {
                  color: 'transparent',
                },
              },
            ],
          },
          {
            name: this.$t('home.unstart'), //'未开始'
            type: 'pie',
            radius: ['48%', '58%'],
            center: ['30%', '53%'],
            emphasis: {
              scale: false,
            },
            label: {
              show: true,
              position: 'center',
              formatter: `{b|${total}}\n${this.$t('home.total_tasks')}`,
              rich: {
                b: {
                  fontSize: 20,
                  fontWeight: 'bold',
                  color: '#333333',
                  lineHeight: '26',
                },
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                name: this.$t('home.unstart'), //'未开始'
                value: resInfo.waiting,
                percentself: resInfo.waitingPercent,
                itemStyle: {
                  color: '#CCCCCC',
                },
              },
              {
                value: total - resInfo.waiting,
                itemStyle: {
                  color: 'transparent',
                },
              },
            ],
          },
        ],
      };
      // 绘制图表
      myChart.setOption(option);
      this.myChart = myChart;
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep {
  .ivu-card-head p {
    width: auto;
  }
  .ivu-card-body {
    padding-right: 6px;
  }
}
.title-item {
  padding: 0 5px;
  height: 18px;
  background: #f0f0f0;
  border-radius: 3px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 12px;
  color: #b2b2b2;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  margin-left: 6px;
}
.top-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title {
    display: inline-block;
    margin-right: 5px;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
  }
}
#task-overview {
  width: 100%;
  height: 100%;
}
</style>
